import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-details.module.scss';
import Header from '../../../../../../../components/Stake/header';
import bnbFineIcon from '../../../../../../../assets/images/bnb-fine.svg';
import * as bnbFineStakeActions from '../../../../../../../actions/bnb-fine-stake-actions';
import { formatToken } from '../../../../../../../helpers/token-helper';

const StakeDetails = () => {
  const dispatch = useDispatch();
  const { amount } = useSelector((state) => state.BnbFineStake.stake);

  return (
    <>
      <Header
        icon={bnbFineIcon}
        title='FINE/BNB-Staking'
        onClickBack={() => dispatch(bnbFineStakeActions.stakeSettings())}
      />
      <div className={stylesParent.cardContent}>
        <div>
          <div className={stylesParent.cardTextRow}>
            <div className={stylesParent.cardTextRowLabel}>You Are Staking:</div>
            <div className={stylesParent.cardTextRowValue}>
              <b>{formatToken(amount)} FINE/BNB</b>
            </div>
          </div>
        </div>
        <div className={styles.descriptionContainer}>
          <div className={styles.descriptionItem}>
            <span>*</span> Unlike some other staked assets, there is a fee should you unstake your
            staked assets early on. The longer you stake your FINE/BNB assets, the lower the fee is
            to unstake your tokens.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(bnbFineStakeActions.stakeSend({ amount }))}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Stake Now
          </Button>
        </div>
      </div>
    </>
  );
};

export default StakeDetails;
